import React from 'react';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: 'danger' | 'primary';
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  onCancel,
  onConfirm,
}: ConfirmModalProps): JSX.Element | null {
  if (!open) return null;

  const confirmClass = confirmVariant === 'danger' ? 'btn-danger' : 'btn-primary';

  return (
    <div className="quit-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="confirm-title">
      <div className="quit-modal-card">
        <h5 id="confirm-title" className="mb-2">{title}</h5>
        <p className="mb-3">{message}</p>
        <div className="d-flex gap-2 justify-content-end">
          <button type="button" className="btn btn-outline-light btn-sm" onClick={onCancel}>{cancelLabel}</button>
          <button type="button" className={`btn ${confirmClass} btn-sm`} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

